function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCloseLight = function SvgCloseLight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32"
  }, props), /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h32v32H0z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m17.41 16 8.3-8.29a1 1 0 1 0-1.42-1.42L16 14.59l-8.29-8.3a1 1 0 0 0-1.42 1.42l8.3 8.29-8.3 8.29a1 1 0 0 0 0 1.42 1 1 0 0 0 1.42 0l8.29-8.3 8.29 8.3a1 1 0 0 0 1.42 0 1 1 0 0 0 0-1.42Z",
    style: {
      fill: "#1d1d1b"
    }
  })));
};
export default SvgCloseLight;